import { observer } from 'mobx-react-lite'
import { PresetList, PresetListItem } from 'shared/Preset'
import { type IIconsVector } from 'shared/ui'
import { uiStore } from 'shared/store/uiStore'
import { type IAICallingType } from 'entities/AICalling/api/types'
import { ChatbotPath } from 'pages/chatbot/route/chatbotPath'
import type { CreateChatbotStore } from 'pages/chatbot/store/chatbotCreateStore'
import styles from './styles.module.scss'

export type IAICallingTemplate = {
  type: IAICallingType
  icon: IIconsVector
  name: string
  description: string
  isNew?: boolean
  isDisabled?: boolean
}

export const AITemplatesMap: Record<IAICallingType, IAICallingTemplate> = {
  faq_information: {
    type: 'faq_information',
    icon: 'messageQuestion',
    name: 'FAQ / Information',
    description: 'Answer questions about your business or products',
  },
  take_message: {
    type: 'take_message',
    icon: 'edit',
    name: 'Take Message',
    description: 'Capture caller details and their message',
  },
  custom: {
    type: 'custom',
    icon: 'settings',
    name: 'Custom',
    description: 'Create a custom AI Agent with your instructions',
  },
}

export const aiTemplates = Object.values(AITemplatesMap)

export const CallingContent = observer(({ store }: { store: CreateChatbotStore }) => {
  const { onClose } = store

  const onNext = (selectedType: IAICallingType) => {
    onClose()
    uiStore.changeRoute({ path: ChatbotPath.callingNew(selectedType) })
  }
  return (
    <>
      <PresetList className={styles.presetList}>
        {aiTemplates.map((template) => (
          <PresetListItem
            key={template.name}
            onClick={() => onNext(template.type)}
            icon={template.icon}
            name={template.name}
            description={template.description}
            isNew={template.isNew}
          />
        ))}
      </PresetList>
    </>
  )
})
